import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { FileType } from '@_/constants';
import { useImageObjectUrl } from '@_/hooks';
import { buttonCommonI18n } from '@_/i18n-common';
import { Avatar, Button } from '@_/ui';
import { FileSelector } from '../FileSelector/index.ts';

export interface AvatarUploaderProps {
  disabled?: boolean;
  onChange?: (file: File | null) => void;
  value: File | string | null;
}

export function AvatarUploader({ disabled = false, onChange, value }: AvatarUploaderProps) {
  const avatarUrl = useImageObjectUrl({ value });

  const handleSelectFile = useCallback(
    (data: { file: File }) => {
      onChange?.(data.file);
    },
    [onChange]
  );

  return (
    <div className="flex items-center gap-x-3">
      {avatarUrl ? (
        <Avatar className="size-16" src={avatarUrl} />
      ) : (
        <svg
          className="size-16 rounded-full bg-gray-100 text-gray-300"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      )}

      <div className="flex items-center divide-x divide-gray-200">
        <div className="px-3">
          <FileSelector
            disabled={disabled}
            fileType={FileType.Image}
            onSelectFile={handleSelectFile}
            render={<Button color="primary" variant="plain" />}
          >
            <FormattedMessage
              {...(value ? buttonCommonI18n.update : buttonCommonI18n.uploadPhoto)}
            />
          </FileSelector>
        </div>

        {!!value && (
          <div className="px-3">
            <Button disabled={disabled} onClick={() => onChange?.(null)} variant="plain">
              <FormattedMessage {...buttonCommonI18n.remove} />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
